import React, { ReactNode, useEffect, useState } from "react";
import { Box } from "@mui/material";
import { Tab } from "@mui/material";

import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import CloseIcon from "@mui/icons-material/Close";

import "./tab-bar-ui.scss";
import TextField from "../text-field/text-field";
import images from "../../assets/images";

interface TabItem {
  tab_order: number;
  title: string;
  content?: string | ReactNode;
  data?: any;
  remove_tab?: boolean;
  tabIcon?: string;
}
export interface ITabProps {
  tabs: TabItem[];
  activeTabValue?: number;
  setActiveTabValue?: React.Dispatch<React.SetStateAction<number | undefined>>;
  onEditTabTitle?: (tabId: number, newTitle: string) => void;
  handleTabChange?: () => void;
  handleRemoveTab?: (tabId: number) => void;
}

export const TabBarUi = (props: TabProps) => {
  const { tabs, onEditTabTitle, activeTabValue, setActiveTabValue, handleTabChange, handleRemoveTab } = props;
  const [value, setValue] = useState(0);
  const [editableTabId, setEditableTabId] = useState<number | null>(null);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setActiveTabValue && setActiveTabValue(newValue);
    handleTabChange && handleTabChange();
  };

  const handleTabDoubleClick = (tabId: number) => {
    setEditableTabId(tabId);
  };

  const handleEditTabTitle = (
    event: React.ChangeEvent<HTMLInputElement>,
    tabId: number,
  ) => {
    onEditTabTitle && onEditTabTitle(tabId, event.target.value);
  };

  useEffect(() => {
    if (setActiveTabValue && Boolean(tabs?.length)) setActiveTabValue(value);
    // eslint-disable-next-line
  }, [tabs]);

  return (
    <Box>
      <TabContext value={activeTabValue ?? value}>
        <Box>
          <TabList
            className="account-payble-tabsui-wrap"
            onChange={handleChange}
          >
            {tabs.map((tab: TabItem) => (
              <Tab
                className="account-payble-tab-items"
                key={tab.tab_order}
                label={
                  onEditTabTitle && editableTabId === tab.tab_order ? (
                    <TextField
                      value={tab.title}
                      autoFocus
                      onBlur={() => setEditableTabId(null)}
                      onChange={(e: any) =>
                        handleEditTabTitle(e, tab.tab_order)
                      }
                    />
                  ) : handleRemoveTab ? (
                    <div className="Tabs--Title">
                      <div>{tab.title}</div>
                      {!tab.remove_tab && (
                        <CloseIcon
                          style={{ fontSize: "15px", cursor: "pointer" }}
                          onClick={() => {
                            handleRemoveTab(tab.tab_order);
                          }}
                        />
                      )}
                    </div>
                  ) : (
                    <div className="text-display">
                      <img src={images.common[tab.tabIcon]} />
                      {tab.title}
                    </div>
                  )
                }
                wrapped
                onDoubleClick={() => handleTabDoubleClick(tab.tab_order)}
              />
            ))}
          </TabList>
        </Box>
        {tabs.map(
          (tab: TabItem, index: number) =>
            tab.content && (
              <TabPanel value={index} key={tab.tab_order}>
                {value === index && tab.content}
              </TabPanel>
            ),
        )}
      </TabContext>
    </Box>
  );
};

export default TabBarUi;
